import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Route,
  Redirect,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Switch,
  Select,
  Checkbox,
  Button,
  Modal,
  Cascader,
  message,
  Slider,
  InputNumber,
  Tag,
  Upload,
  Alert,
  notification,
  Progress,
} from "antd";
import cookie from "react-cookies";
import "./list.less";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import moment from "moment";
import qs from "qs";
import axios from "axios";

import MyUpload from "../../components/MyUpload/index.tsx";
import { UPLOAD_FILE_PATCH, UPLOAD_FILE_MERGE } from "../../api/upload";
import { SET_TASK } from "../../api/task";
import { useTranslation } from "react-i18next";

const { Dragger } = Upload;

const fixedSize = (params = 700, fixedSize = 100) => {
  params = Number(params);
  fixedSize = Number(fixedSize);
  if (!params || !fixedSize) return "数据有误";

  let arrayObjec = [],
    start = 0;
  if (params <= fixedSize) {
    arrayObjec.push({ start: 0, end: params, isUploaded: false });
  } else {
    for (let i = 0; i < params; i++) {
      if (i - start == fixedSize)
        arrayObjec.push({ start: start, end: i, isUploaded: false }),
          (start = i);
    }

    let len = arrayObjec.length;
    if (arrayObjec[len - 1].end < params)
      arrayObjec.push({
        start: arrayObjec[len - 1].end,
        end: params,
        isUploaded: false,
      });
  }

  return arrayObjec;
};

const blobSlice = (blob, startByte, endByte) => {
  if (blob.slice) {
    return blob.slice(startByte, endByte);
  }
  // 兼容firefox
  if (blob.mozSlice) {
    return blob.mozSlice(startByte, endByte);
  }
  // 兼容webkit
  if (blob.webkitSlice) {
    return blob.webkitSlice(startByte, endByte);
  }
  return null;
};

const openNotificationWithIcon = (type, title, intro) => {
  notification[type]({
    message: title,
    description: intro,
  });
};

const List = () => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const { t } = useTranslation();
  const history = useHistory();

  const [isCancel, setIsCancel] = useState(0);
  const [filename, setFilename] = useState("");
  // 上传文件时触发
  const fileChange = (files) => {
    // console.log(files);
    // if (files[0].size > 2 * 1024 * 1024 * 1024) {
    //   message.error("The file size exceeds 2GB, please upload again");
    //   return;
    // }

    let arr = [];
    files.map((file) => {
      let newFile = {
        ...file,
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
        lastModified: file.lastModified,
        percent: 0,
        status: "wait",
      };
      setFilename(file.name);
      arr.push(newFile);
      // chunkList.push(newFile);
    });
    // console.log(arr);
    setFileList([...arr]);
    setChunkList([...arr]);

    // console.log(fileList, chunkList);
    return false;
  };

  const onFileRemove = (file) => {
    // console.log(file);
    let newFileList = fileList.filter((item) => item.uid != file.uid);
    setTotal((total) => total - file.size);
    setFileList([...newFileList]);
    setChunkList([...newFileList]);
    source.cancel("上传请求被用户取消");
    if (isUploadBegin) {
      setIsCancel(1);
      localStorage.setItem("isCancelUpload", 1);
    } else {
      setIsCancel(0);
      localStorage.removeItem("isCancelUpload");
    }
    setIsUploadBegin(false);
  };

  // --------------------

  // 上传文件form
  const [uploadForm] = Form.useForm();

  // 是否开始上传
  const [isUploadBegin, setIsUploadBegin] = useState(false);

  // 文件列表
  const [fileList, setFileList] = useState([]);

  // 分片列表
  const [chunkList, setChunkList] = useState([]);

  // 请求列表
  const [requestLists, setRequestLists] = useState([]);

  // 上传文件总大小
  const [total, setTotal] = useState(0);

  // 已上传大小
  const [uploadedNum, setUploadedNum] = useState(0);

  // 初始化进入数据
  useEffect(() => {
    setTotal(0);
    setUploadedNum(0);

    return () => {
      source.cancel("上传请求被用户取消");
    };
  }, []);

  useEffect(() => {
    // console.log("每次上传文件后数据", uploadedNum, total);
    // console.log("----------------");
    if (uploadedNum > 0 && total > 0 && uploadedNum >= total) {
      uploadForm.resetFields();
      setFileList([]);
      setChunkList([]);
      // setTotal(0);
      // setUploadedNum(0);
      setIsUploadBegin(false);
    }
  }, [uploadedNum]);

  /**
   * 发起上传请求
   * @param {Object} params 请求参数
   */
  const fetch = async (params) => {
    const isCancelUpload = localStorage.getItem("isCancelUpload");

    if (isCancel > 0 || isCancelUpload) {
      // console.log(isCancel, params);
      setIsCancel(0);
      setIsUploadBegin(false);
      return;
    }

    let res = await UPLOAD_FILE_PATCH({
      task_id: params.task_id,
      chunk: params.chunk,
      file: params.file,
    });
    // console.log(params);
    // console.log(res)
    if (res.data.code == 0) {
      // 运算上传进度
      // console.log("已上传大小", uploadedNum);
      // console.log(params);
      // console.log("总大小", total);
      // console.log("当前文件", chunkItem.fileChunk);
      // console.log("当前文件片大小", chunkItem.fileChunk.size);
      // console.log("--------------");
      setUploadedNum((num) => num + params.file.size);
      // console.log({
      //   task_id: params.task_id,
      //   chunk: params.chunk,
      //   file: params.file,
      // });
      // dispatch(set(params));
      return params;
    }
    return false;
  };

  /**
   * 接口请求最大并发量控制
   * @param { Array } urls 接口请求地址数组集合
   * @param { Number } max 最大并发量
   * @param { Function } callback 回调函数
   */
  const maxRequestLimit = (arr, max, callback) => {
    // 如果没有传入urls或max则不继续执行
    if (!arr || !max) return;

    // 当请求地址数组集合长度为0，则执行回调函数（如果有的话），并结束后续执行
    if (arr.length === 0) {
      if (callback) callback();
      return;
    }

    let fetchArr = [], // 存储并发max的promise数组
      i = 0;

    const isCancelUpload = localStorage.getItem("isCancelUpload");

    if (isCancel > 0 || isCancelUpload) {
      // console.log(fetchArr);

      fetchArr = [];
      arr = [];
      setIsCancel(0);
      setIsUploadBegin(false);
      return;
    }

    function toFetch() {
      // console.log(isCancel, fetchArr, arr);

      if (isCancel > 0 || isCancelUpload) {
        fetchArr = [];
        arr = [];
        setIsCancel(0);
        setIsUploadBegin(false);
        return;
      }

      // 所有的请求都受理，则返回一个resolve
      if (i === arr.length) return Promise.resolve();

      // 取出第i个url， 放入fetch里面 , 每取一次i++
      let one = fetch(arr[i++]);

      //将当前的promise存入并发数组中
      fetchArr.push(one);

      // 当promise执行完毕后，从数组删除
      one.then((res) => {
        // console.log(res);
        fetchArr.splice(fetchArr.indexOf(one), 1);
      });

      let p = Promise.resolve();

      // 当并行数量达到最大后， 用race比较 第一个完成的， 然后再调用一下函数自身。
      if (fetchArr.length >= max) p = Promise.race(fetchArr);

      return p.then(() => toFetch());
    }

    // arr循环完后， 现在fetchArr里面剩下的promise对象， 使用all等待所有的都完成之后执行callback
    toFetch()
      .then(() => Promise.all(fetchArr))
      .then(() => callback());
  };

  function listener (e) {
    (e || window.event).preventDefault();
    let confirmationMessage = t("pages.createTask.leaveMsg");
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  };

  useEffect(() => {
    if (isUploadBegin) {
      window.addEventListener("beforeunload", listener);
    }

    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, [isUploadBegin]);

  return (
    <div className="task create px-5">
      <Alert
        className="mb-3"
        // message="Error Text"
        description={
          <div>
            <div>{t("pages.createTask.tip1")}</div>
            <div>{t("pages.createTask.tip2")}</div>
            <div>{t("pages.createTask.tip3")}</div>
          </div>
        }
        type="error"
      />

      <Form
        form={uploadForm}
        onFinish={async (vals) => {
          // console.log("form值:", vals);
          setIsUploadBegin(true);
          if (vals.file?.length <= 0) {
            message.error(t("pages.createTask.msgErr1"));
            return false;
          }
          // console.log("目标文件夹:", uploadFolderFolderItem);
          // console.log("文件列表:", fileList);
          // console.log("分片文件列表:", chunkList);

          // 将文件列表分片
          let newChunkList = [];
          chunkList.map((item, ind) => {
            if (!!item) {
              // console.log("file:", typeof item);
              // console.log(
              //   "file:",
              //   new Blob([item.file], { type: item.type })
              // );
              const { 0: fname, 1: fext } = item.name.split("."); // 获取文件的名字和拓展名
              newChunkList.push({
                ...item,
                // 每片2M
                chunk: [
                  ...fixedSize(item.size, 2 * 1024 * 1024).map(
                    (chunkItem, chunkInd) => {
                      // console.log(chunkItem, chunkInd);
                      return {
                        ...item,
                        chunk: chunkInd,
                        isFinish: false,
                        fileChunk: new File(
                          [
                            blobSlice(
                              item.file,
                              chunkItem.start,
                              chunkItem.end
                            ),
                          ],
                          `${fname}-${chunkInd}-${fext}`
                        ),
                      };
                    }
                  ),
                ],
                isFinish: false,
              });
            }
          });

          // console.log("分片后数组:", newChunkList);

          setChunkList([...newChunkList]);

          // 开始进行分片上传
          let chunkFileList = []; // 上传文件组
          let requestList = []; // 将要上传数组
          let chunkUpFinishList = []; // 合并上传完成接口数组

          newChunkList.map(async (item, ind) => {
            // console.log("每块文件", item);
            // setRequestLists((list) => [
            //   ...list,
            //   {
            //     uid: item.uid,
            //     name: item.name,
            //     chunk: item.chunk.length,
            //   },
            // ]);
            chunkFileList.push({
              uid: item.uid,
              name: item.name,
              chunk: item.chunk.length,
            });

            item.chunk.map(async (chunkItem, chunkInd) => {
              // console.log(chunkItem);
              requestList.push({
                task_id: item.uid,
                chunk: chunkItem.chunk,
                file: chunkItem.fileChunk,
              });
            });
          });

          // console.log(requestList);

          await maxRequestLimit(requestList, 1, async () => {
            console.log("执行完成");
            const isCancelUpload = localStorage.getItem("isCancelUpload");
            if (isCancelUpload) {
              localStorage.removeItem("isCancelUpload");
              setIsCancel(0);
              setIsUploadBegin(false);
              return;
            }
            // console.log(total, uploadedNum);
            await chunkFileList.map(async (item) => {
              let successRes = null;
              successRes = await UPLOAD_FILE_MERGE({
                task_id: item.uid,
                chunks: item.chunk,
                filename: item.name,
              });
              // console.log(successRes);
              if (successRes.data.code !== 0) {
                if (successRes.data.code == -11001) {
                  message.error(t("pages.createTask.msgErr3"));
                }
                if (successRes.data.code == -11002) {
                  message.error(t("pages.createTask.msgErr4"));
                }
                message.error(
                  t("pages.createTask.msgErr2") + "" + successRes.data.code
                );
                return false;
              }

              chunkUpFinishList.push(item.name);

              // console.log(successRes);
              // console.log(requestList);
              // console.log(chunkFileList);
              // console.log(chunkUpFinishList);

              if (chunkFileList.length == chunkUpFinishList.length) {
                await openNotificationWithIcon(
                  "success",
                  t("pages.createTask.msgTitle"),
                  t("pages.createTask.msgJoin")
                );
                // await dispatch(isStop());

                await uploadForm.resetFields();
                await setFileList([]);
                await setChunkList([]);
                // await setTotal(0);
                // await setUploadedNum(0);
                await setIsUploadBegin(false);

                // console.log(successRes.data);

                if (successRes?.data?.code == 0) {
                  const SETTASKRES = await SET_TASK({
                    media_id: successRes.data.data.task_id,
                    filename: filename,
                  });
                  // console.log(SETTASKRES);
                  if (200 == SETTASKRES.data.code) {
                    // history.push("/index/task/list");
                    window.location.href = "/index/task/list";
                  }
                }
              }
            });
          });
        }}
      >
        <div className="upload-cont mb-3">
          <Form.Item name="file">
            {/* {isUploadBegin && <div className="begin-cover"></div>} */}
            <MyUpload
              // {...props}
              onChange={fileChange}
              showFileList={fileList}
              onRemove={onFileRemove}
              multiple={false}
              fileSpan={8}
              listType="filelist"
              accept={[".svs", ".mrxs", ".tif", ".zip"]}
              disbaled={isUploadBegin}
            >
              <div className="">
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  {t("pages.createTask.uploadText")}{" "}
                </p>
                {/* <p className="ant-upload-hint">
                  {t("pages.createTask.uploadTip")}
                </p> */}
              </div>
            </MyUpload>
          </Form.Item>
        </div>
        <div className="mb-3">
          <Progress
            status="active"
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
            percent={
              total == 0 ? total : Math.floor((uploadedNum / total) * 100)
            }
          />
        </div>

        <div className="btn-cont">
          <Button
            type="primary"
            size="large"
            disabled={isUploadBegin || !fileList.length ? true : false}
            onClick={() => {
              if (fileList.length) {
                let totalNum = 0;
                fileList.map((item) => {
                  totalNum += item.size;
                });
                setTotal(totalNum);
              }

              // console.log(fileList);

              // // 将上传文件数据传入任务列表
              // dispatch(push(fileList));
              // dispatch(isStart());
              // return;
              uploadForm.submit();
              openNotificationWithIcon(
                "success",
                t("pages.createTask.msgTitle"),
                t("pages.createTask.msgJoin")
              );
            }}
          >
            {`${
              isUploadBegin
                ? t("pages.createTask.uploadBtn")
                : t("pages.createTask.subBtn")
            }`}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default List;
